import { Flow_0_0_2 } from '@flexus/core';

export const BUI_40: Flow_0_0_2 = {
	id: '40',
	name: 'payment_approved_invalid_claim',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Send rejection letter'
		},
		viewRoles: {
			0: '--'
		}
	},
	startNode: '',
	nodes: {}
};
